<form [formGroup]="drawingForm" appBreadcrumbFormLinker>
  <section fxLayout="column" fxLayoutGap="24px">
    <article fxLayout="row wrap" fxLayoutGap="24px">
      <div class="image-preview" fxLayout="column" fxFlex="154px" fxLayoutGap="24px">
        <div class="drawing-image">
          <app-drawing-library-image-preview [drawingImage]="getDrawingImage()" [areImagesUploading]="canShowImageLoader()"></app-drawing-library-image-preview>
        </div>
      </div>
      <div fxFlex fxLayout="column">
        <div fxLayout="column">
          <article fxLayout="row wrap" fxLayoutGap="16px">
            <mat-form-field fxFlex>
              <mat-label>{{ 'DESIGN_LIBRARY.DETAILS.DESIGN_NAME' | bmsTranslate }}</mat-label>
              <input matInput type="text" formControlName="name" />
              <mat-error *ngIf="canShowErrorForFormControl('required', 'name')">
                {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
              </mat-error>
              <mat-error appDataCy="name-taken-error-message" *ngIf="canShowErrorForFormControl('identifierTaken', 'name')">
                {{ 'GENERAL.ERRORS.NAME_DUPLICATE' | bmsTranslate }}
              </mat-error>
              <mat-error *ngIf="checkIfNameIsUnique()">
                {{ 'DESIGN_LIBRARY.LIBRARY.ERRORS.ADDING_DUPLICATED_NAME' | bmsTranslate }}
              </mat-error>
            </mat-form-field>
            <mat-form-field fxFlex>
              <mat-label>{{ 'GENERAL.SHAPE' | bmsTranslate }}</mat-label>
              <mat-select formControlName="shape" disableOptionCentering>
                <mat-option *ngFor="let drawingShape of drawingShapes" [value]="drawingShape" [attr.value]="drawingShape">
                  {{ getShape(drawingShape) }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="canShowErrorForFormControl('required', 'shape')">
                {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
              </mat-error>
            </mat-form-field>
          </article>
          <article class="flew-row gap-16" *ngIf="isDrawingTypeBmp()">
            <div class="flex-1">
              <mat-form-field fxFlex>
                <mat-label>{{ 'DESIGN_LIBRARY.DETAILS.DESIGN_CODE' | bmsTranslate }}</mat-label>
                <input matInput type="text" formControlName="code" />
                <mat-error *ngIf="canShowErrorForFormControl('required', 'code')">
                  {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="flex-1 gap-16">
              <mat-form-field class="flex-1">
                <mat-label>{{ 'GENERAL.DIMENSIONS.WIDTH' | bmsTranslate }}</mat-label>
                <input matInput vdwL10nDecimal type="number" formControlName="widthInPx" />
                <span matSuffix>{{ 'GENERAL.UNIT.PIXEL' | bmsTranslate }}</span>
              </mat-form-field>
              <mat-form-field class="flex-1">
                <mat-label>{{ 'GENERAL.DIMENSIONS.HEIGHT' | bmsTranslate }}</mat-label>
                <input matInput vdwL10nDecimal type="number" formControlName="heightInPx" />
                <span matSuffix>{{ 'GENERAL.UNIT.PIXEL' | bmsTranslate }}</span>
              </mat-form-field>
            </div>
          </article>
          <article class="flex-row gap-16 flex-start-center" *ngIf="isDrawingTypeBmp()">
            <div class="flex-column">
              <mat-form-field class="flex-1">
                <mat-label>{{ 'TEXTILE_DATA.MACHINE_QUALITY.WEFT_SELECTION.TITLE' | bmsTranslate }} {{ 'TEXTILE_DATA.MACHINE_QUALITY.WEFT_SELECTION.COLUMNS' | bmsTranslate }}</mat-label>
                <input matInput vdwL10nDecimal type="number" formControlName="nrColumnsForWeftSelection" />
                <span matSuffix>{{ 'GENERAL.UNIT.PIXEL' | bmsTranslate }}</span>
              </mat-form-field>
            </div>
            <div class="flex-column">
              <mat-slide-toggle formControlName="threadByThread" [disabled]="hasDrawingConfigurations()">{{ 'DESIGN_LIBRARY.DETAILS.THREAD_BY_THREAD' | bmsTranslate }}</mat-slide-toggle>
            </div>
          </article>
        </div>
      </div>
    </article>
    <ng-container *ngIf="isDrawingTypeBmp()">
      <article fxLayout="column" fxLayoutGap="24px">
        <mat-expansion-panel class="mat-elevation-z mat-expansion-panel" [expanded]="canExpand()" [disabled]="true" hideToggle="true">
          <mat-expansion-panel-header class="configuration-expansion-panel-header extra-padding" expandedHeight="68px" collapsedHeight="68px">
            <mat-panel-title fxFlex="100" fxLayout="row" fxLayoutAlign="space-between center">
              <h3 class="font-weight-semibold no-margin">{{ 'DESIGN_LIBRARY.DETAILS.CONFIGURATION.CONFIGURATION' | bmsTranslate: {count: 2} }}</h3>
              <div class="button-skeleton-wrapper standard-btn">
                <button mat-icon-button class="mat-icon-action-button-lg-with-border white-button" (click)="addConfigurationToDrawing()">
                  <mat-icon svgIcon="add"></mat-icon>
                </button>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div *ngFor="let drawingConfigurationForm of getDrawingConfigurationForms(); let configurationIndex = index" class="testing gap" fxLayout="column" fxLayoutGap="24px">
            <app-drawing-configuration
              [form]="drawingConfigurationForm"
              [drawingId]="drawing?.id"
              [hasMissingDesign]="drawing?.missingDesign"
              [drawingConfigurationIndex]="getConfigurationIndexForView(configurationIndex)"
              [drawingDimensionsInPx]="drawingImage.dimensionsInPx"
              [existingQualitiesAndColorSets]="getExistingQualitiesAndColorSetsOfTheOtherDrawingConfigurations(configurationIndex)"
              (delete)="deleteConfiguration(configurationIndex)"
              [canShowInvalidFormMessageError]="canShowInvalidFormMessageError"
              fxFlex
              fxLayout="column"
              fxLayoutGap="24px"
            >
            </app-drawing-configuration>
          </div>
        </mat-expansion-panel>
      </article>
    </ng-container>
  </section>
</form>
